var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ci:youtube"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0048 16.1571H9.98817C9.93651 16.1571 4.76734 16.1471 3.46317 15.793C3.11079 15.698 2.78952 15.5122 2.53154 15.2541C2.27356 14.9959 2.08791 14.6746 1.99317 14.3221C1.75866 12.9991 1.64541 11.6574 1.65484 10.3138C1.64879 8.96798 1.7651 7.6244 2.00234 6.29964C2.09975 5.94661 2.28626 5.62455 2.54397 5.36436C2.80168 5.10417 3.12193 4.91459 3.47401 4.8138C4.74234 4.48047 9.76901 4.48047 9.98234 4.48047H9.99984C10.0523 4.48047 15.2348 4.49047 16.5257 4.84464C17.2415 5.0388 17.8007 5.59797 17.994 6.3138C18.2357 7.64214 18.3498 8.98964 18.3332 10.3396C18.339 11.6838 18.2224 13.0258 17.9848 14.3488C17.8889 14.7009 17.7025 15.0217 17.4442 15.2794C17.1859 15.5371 16.8646 15.7228 16.5123 15.818C15.2457 16.1538 10.2182 16.1571 10.0048 16.1571ZM8.33817 7.81797L8.33401 12.818L12.6773 10.318L8.33817 7.81797Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.1080d6f59ad3fdea0d1cbe83adaf402e.svg";
export { ForwardRef as ReactComponent };